/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Stat } from './Stat';

class OpenStoreOrderStat extends Stat {
    constructor() {
        super();
        this.baseUrl += '/openStoreOrderStat';
    }

    openStoreOrderStatList({ statDateDay, paymentType, currentPage, pageSize } = {}) {
        let statBeginDate = null;
        let statEndDate = null;
        if (statDateDay != null && statDateDay.length === 2) {
            statBeginDate = statDateDay[0];
            statEndDate = statDateDay[1];
        }
        return super.get('/openStoreOrderStatList', {
            statBeginDate,
            statEndDate,
            paymentType,
            currentPage,
            pageSize,
        });
    }
}

export default new OpenStoreOrderStat();
export { OpenStoreOrderStat };
